import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../context';
import fnolServices from '../../services/fnolServices';
import { PrimaryButton, SecondaryButton } from '../../components';
import {
  STEP_ANSWER_QUESTIONS,
  STEP_CONTACT_INFORMATION,
} from '../../CONSTANTS';
import { FileItem } from './components';
import { Dropzone } from './components/DropZone';
import ButtonWrapper from '../../components/ButtonWrapper';

const UploadFileView = () => {
  const { setStep, fnolTemplate } = useFnol();

  const { t } = useTranslation();

  const [newFiles, setNewFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleIsButtonDisabled = (value) => {
    setIsDisabled(value);
  };

  const uploadAttachments = (files) => {
    setNewFiles((state) => [...state, ...files]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(STEP_CONTACT_INFORMATION);
  };

  const handleGoBackClick = () => setStep(STEP_ANSWER_QUESTIONS);

  const handleOnRemoveFile = async (fileName) => {
    handleIsButtonDisabled(true);
    try {
      await fnolServices.removeAttachment(fnolTemplate.fnolKey, fileName);
    } catch (error) {
      console.log(error);
      handleIsButtonDisabled(false);
    }
    handleIsButtonDisabled(false);
  };

  return (
    <>
      <h3>{t('uploadFiles.header')}</h3>
      <form onSubmit={handleSubmit}>
        <Dropzone uploadAttachments={uploadAttachments} />
        <FileListNew>
          {fnolTemplate.attachments
            .filter(
              (file) =>
                !newFiles.some((newFile) => newFile.name === file.filename)
            )
            .map((file) => ({ name: file.filename }))
            .map((file, index) => (
              <FileItem
                key={index}
                file={file}
                removeFile={handleOnRemoveFile}
                doUpload={false}
              />
            ))}
          {newFiles.map((file, index) => (
            <FileItem
              key={index}
              file={file}
              removeFile={handleOnRemoveFile}
              doUpload={true}
              isDisabled={isDisabled}
              handleIsButtonDisabled={handleIsButtonDisabled}
            />
          ))}
        </FileListNew>
        <ButtonWrapper>
          <SecondaryButton onClick={handleGoBackClick}>
            {t('buttons.back')}
          </SecondaryButton>
          <PrimaryButton type='submit' disabled={isDisabled}>
            {t('buttons.continue')}
          </PrimaryButton>
        </ButtonWrapper>
      </form>
    </>
  );
};

export default UploadFileView;

const FileListNew = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  justify-content: space-between;
  padding: 0;
  gap: 0.525rem;
  margin-bottom: 1rem;
`;
